import React, { useEffect } from 'react'
import { BannerContainer, Container, Content, OptionsIcon, PdfContainer, Section, SectionTitle, Title } from './styled'
import { Icon } from 'ui/styled'
import FileCard from 'components/Cards/File'
import { parseCustomFieldHtml } from 'utils'
import ExternalResourceLink from 'components/ExternalResourceLink'

export default function CoursePdf({ course }) {
  const parsedContent = parseCustomFieldHtml(course?.description || course?.content || '')

  return (
    <>
      <Container>
        <Content>
          <OptionsIcon><Icon icon="pdf" /></OptionsIcon>
          <Title>{course?.title}</Title>
        </Content>
        <Section>
          <SectionTitle>Files</SectionTitle>
          <PdfContainer>
            <FileCard file={course} />
            <ExternalResourceLink course={course} />
            <Title dangerouslySetInnerHTML={parsedContent} />
          </PdfContainer>
        </Section>
      </Container>
    </>
  )
}
